import React from 'react';
import classnames from 'classnames';
import { Query } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import { mapAfter } from 'apollo-relay/update-query';

import LoadingProgress from 'lib/react-router/loading-progress';
import ErrorPage from 'four-nets/errors/error-page';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import Member from '../member/member';
import query, { GroupMembersLoaderQuery, GroupMembersLoaderQueryVariables } from './group-members-loader.graphql';
import defaultStyles from './group-members.scss';

export interface Props {
    styles: typeof defaultStyles;
    id: string;
}

interface State {
    loading: boolean;
}

class GroupMembers extends React.PureComponent<Props, State> {
    state: State = { loading: false };

    render() {
        const { id, styles } = this.props;

        return (
            <Query<GroupMembersLoaderQuery, GroupMembersLoaderQueryVariables>
                query={query}
                variables={{ id, first: 10 }}
                fetchPolicy='cache-first'
            >
                {({ error, data, loading, fetchMore }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.group ? (
                                <div className={styles.wrapper}>
                                    <div className={styles.section}>
                                        <div className={styles.sectionTitle}>
                                            <FormattedMessage id='GROUP_MEMBERS' />
                                            &nbsp; ({data && data.group && data.group.membersCount})
                                        </div>
                                        <ul className={classnames(styles.noMargin, styles.noPadding)}>
                                            {data.group.members && data.group.members.edges
                                                ? data.group.members.edges.map(edge =>
                                                      edge && edge.node ? <Member {...edge.node} /> : null
                                                  )
                                                : null}
                                        </ul>
                                    </div>
                                    {data &&
                                    data.group &&
                                    data.group.members &&
                                    data.group.members.pageInfo.hasNextPage ? (
                                        <FetchMore
                                            disabled={this.state.loading}
                                            loading={this.state.loading}
                                            onClick={() => {
                                                this.setState({ loading: true });
                                                const endCursor =
                                                    data &&
                                                    data.group &&
                                                    data.group.members &&
                                                    data.group.members.pageInfo.endCursor;

                                                fetchMore({
                                                    variables: { after: endCursor },
                                                    updateQuery: (
                                                        previousResult = {} as GroupMembersLoaderQuery,
                                                        { fetchMoreResult = {} as GroupMembersLoaderQuery }
                                                    ) => {
                                                        return {
                                                            ...previousResult,
                                                            ...fetchMoreResult,
                                                            group: {
                                                                ...(previousResult && previousResult.group),
                                                                ...(fetchMoreResult && previousResult.group),
                                                                members: mapAfter(
                                                                    previousResult.group &&
                                                                        previousResult.group.members,
                                                                    fetchMoreResult.group &&
                                                                        fetchMoreResult.group.members
                                                                ),
                                                            },
                                                        } as GroupMembersLoaderQuery;
                                                    },
                                                }).then(() => {
                                                    this.setState({ loading: false });
                                                });
                                            }}
                                        />
                                    ) : null}
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(GroupMembers);
